// Welcome ("Добро пожаловать в Humanteq") — paused per the v2 funnel redesign:
// guests now land directly on onboarding ("Давайте познакомимся"), so /welcome
// only exists to redirect old links. The original screen (logo, "Начать" →
// onboarding, "У меня уже есть аккаунт" → login) can be restored from git
// history (design workspace: pwa-references/humanteq-welcome-v2) if the
// landing step is ever re-enabled.

import { Link, useNavigate } from 'react-router-dom'
import { usePendingSegment } from '../../features/product-segment'
import styles from './Welcome.module.css'

export default function Welcome() {
  const navigate = useNavigate()
  // Guest landing: the pending segment (build variant or ?segment=/cookie)
  // picks the product copy — the breakup build speaks to its own audience.
  const isBreakUp = usePendingSegment((s) => s.segment) === 'break_up'
  return (
    <div className={styles.screen}>
      <section className={styles.content}>
        <div className={styles.logo}>
          <img src="/assets/app-icon.png" alt="Humanteq" width="88" height="88" />
        </div>

        <div className={styles.copy}>
          <h1>Добро пожаловать<br />в Humanteq</h1>
          <p>
            {isBreakUp
              ? 'Понять, где Вы в расставании, и решить, что делать дальше.'
              : 'AI-психолог: когда тревожно и трудно сфокусироваться'}
          </p>
        </div>

        <nav className={styles.actions}>
          <button className={styles.primaryBtn} onClick={() => navigate('/onboarding')}>Начать</button>
          <Link className={styles.textLink} to="/login">У меня уже есть аккаунт</Link>
        </nav>

        <div className={styles.proof}>
          <span><strong>5000+</strong> пользователей</span>
          <span className={styles.dot}>·</span>
          <span className={styles.stars}>★ 4.8</span>
          <span className={styles.dot}>·</span>
          <span>{isBreakUp ? 'Бережная поддержка рядом 24/7' : 'Поддержка психологов и кандидатов психологических наук'}</span>
        </div>
      </section>
    </div>
  )
}
